import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import {
	SelectSurvey,
	SelectSurveyProps,
} from "#src/components/form-controls/select-survey";

interface Props extends Omit<SelectSurveyProps, "name" | "onChange"> {
	name: string;
}

export const RHFSelectSurvey = ({ name, ...other }: Props) => {
	const { control } = useFormContext();

	return (
		<Controller
			name={name}
			control={control}
			render={({ field, fieldState: { error } }) => {
				return <SelectSurvey {...field} {...other} error={error} />;
			}}
		/>
	);
};
